"use client";

import { useEffect } from "react";
import useShoppingCartStore from "@/lib/client/stores/useShoppingCartStore";
import { filterPurchasableCartItems } from "@/lib/shared/utils/filterPurchasableCartItems";

/**
 * Drops cart lines for unpublished/draft products so checkout cannot submit stale CMS state.
 */
export function CartPurchasabilitySync() {
  const cartItems = useShoppingCartStore((s) => s.cartItems);
  const setCartItems = useShoppingCartStore((s) => s.setCartItems);

  useEffect(() => {
    const next = filterPurchasableCartItems(cartItems);
    if (next.length !== cartItems.length) {
      setCartItems(next);
    }
  }, [cartItems, setCartItems]);

  return null;
}
